import React from 'react';
import './Login.css';
import { useState } from 'react'
import { supabase } from './supabaseClient'






function Login() {
  const [loading, setLoading] = useState(false)
  const [email, setEmail] = useState('')

  const handleLogin = async (event) => {
    event.preventDefault()

    setLoading(true)
    const { error } = await supabase.auth.signInWithOtp({ email })

    if (error) {
      alert(error.error_description || error.message)
    } else {
      alert('Check your email for the login link!')
    }
    setLoading(false)
  }

  return (
    <div className='login'>
      <h2 className='ln_title'>SignUp to create new account or Login with our Magic Link</h2>
      <div className='wrapper'>
      
        <div className='center'>
            <div className='line' />
        </div>
        <div className='right'>
        <form className="form-widget" onSubmit={handleLogin}>
          <div>
            <input
              className="inputField"
              type="email"
              placeholder="Your email"
              value={email}
              required={true}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div>
            <button className={'button block'} disabled={loading}>
              {loading ? <span>Loading</span> : <span>Send magic link</span>}
            </button>
          </div>
        </form>
        </div>
      </div>
    </div>
  )
}

export default Login;
